import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT, LobbyBannerContext, UserContext } from 'commons-ui';

import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog, setForceUpdateRows } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { lobbyBannerData: lobbyBannerRows } = useContext(LobbyBannerContext);

	const { toggleIsActiveField, deleteLobbyBanner } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/lobbyBanner/edit',
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: '/dashboard/lobbyBanner/clone',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/lobbyBanner/create'
				});
			};
		case 'deploy': {
			const toggleIsActive = () => {
				return toggleIsActiveField(rowData, lobbyBannerRows, user, app, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Deploy on app?',
					handleAlertConfirmation: toggleIsActive
				});
			};
		}
		case 'remove': {
			const toggleIsActive = () => {
				return toggleIsActiveField(rowData, lobbyBannerRows, user, app, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: toggleIsActive
				});
			};
		}
		case 'delete': {
			const deleteBanner = async () => {
				await deleteLobbyBanner(rowData, lobbyBannerRows, user, app, showAlert);
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Permanently Delete from app?',
					handleAlertConfirmation: deleteBanner
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
